"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
Object.defineProperty(exports, "SnackbarColors", {
  enumerable: true,
  get: function get() {
    return _proptypes.SnackbarColors;
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckCircle = _interopRequireDefault(require("@quintoandar/cozy-icons/CheckCircle"));
var _Warning = _interopRequireDefault(require("@quintoandar/cozy-icons/Warning"));
var _Error = _interopRequireDefault(require("@quintoandar/cozy-icons/Error"));
var _Box = _interopRequireDefault(require("../Box"));
var _proptypes = require("./proptypes");
var _SlideTransition = _interopRequireDefault(require("./SlideTransition"));
var _SnackbarBase = _interopRequireDefault(require("./SnackbarBase"));
var _SnackProgress = _interopRequireDefault(require("./SnackProgress"));
var _SnackbarIcon = _interopRequireDefault(require("./SnackbarIcon"));
var _SnackbarButton = _interopRequireDefault(require("./SnackbarButton"));
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Snackbar = exports.Snackbar = function Snackbar(_ref) {
  var open = _ref.open,
    message = _ref.message,
    autoHideDuration = _ref.autoHideDuration,
    resumeHideDuration = _ref.resumeHideDuration,
    color = _ref.color,
    onClick = _ref.onClick,
    onClose = _ref.onClose,
    buttonLabel = _ref.buttonLabel,
    className = _ref.className,
    ClickAwayListenerProps = _ref.ClickAwayListenerProps;
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    if (onClose) {
      onClose();
    }
  };
  var getIcon = function getIcon() {
    if (color === _proptypes.SnackbarColors.ERROR) {
      return /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        "aria-label": _messages["default"].errorIcon,
        size: "small"
      });
    }
    if (color === _proptypes.SnackbarColors.SUCCESS) {
      return /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
        "aria-label": _messages["default"].successIcon,
        size: "small"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_Warning["default"], {
      "aria-label": _messages["default"].infoIcon,
      size: "small"
    });
  };
  var longButton = buttonLabel && buttonLabel.length >= 12;
  var longButtonString = function longButtonString() {
    return longButton ? 'true' : 'false';
  };
  return /*#__PURE__*/_react["default"].createElement(_SnackbarBase["default"], {
    className: className,
    open: open,
    onClose: handleClose,
    disableWindowBlurListener: true,
    autoHideDuration: autoHideDuration,
    resumeHideDuration: resumeHideDuration,
    TransitionComponent: _SlideTransition["default"],
    ClickAwayListenerProps: ClickAwayListenerProps
    // Adapter foi mui v5
    // https://mui.com/material-ui/migration/v5-component-changes/#update-default-positioning
    ,

    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    message: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SnackProgress["default"], {
      className: "snackProgress",
      color: color,
      animationDuration: autoHideDuration
    }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      display: "flex",
      alignSelf: "flex-start",
      pr: longButton ? 1 : 0
    }, /*#__PURE__*/_react["default"].createElement(_SnackbarIcon["default"], {
      color: color
    }, getIcon()), message)),
    action: buttonLabel && /*#__PURE__*/_react["default"].createElement(_SnackbarButton["default"], {
      variant: "paddingless",
      onClick: onClick,
      "data-longbutton": longButtonString()
    }, buttonLabel)
  });
};
Snackbar.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _proptypes.SnackbarColorPropType,
  buttonLabel: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  autoHideDuration: _propTypes["default"].number,
  resumeHideDuration: _propTypes["default"].number,
  message: _propTypes["default"].node,
  ClickAwayListenerProps: _propTypes["default"].object,
  className: _propTypes["default"].any
} : {};
Snackbar.defaultProps = {
  autoHideDuration: 3000,
  color: _proptypes.SnackbarColors.ATTENTION,
  buttonLabel: '',
  open: false,
  message: ''
};
var _default = exports["default"] = Snackbar;